<template>
  <v-container fluid>
    <v-card>
      <v-toolbar class="elevation-0" height="45" color="gray" v-if="!hideHeader">
        <v-toolbar-title>
          <h1 class="subtitle-1">{{ $t("labels.location") }}</h1>
        </v-toolbar-title>
      </v-toolbar>
      <v-card-title class="mt-0">
        <v-flex xs12 sm4="sm4">
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line="single-line" hide-details
            clearable="clearable">
          </v-text-field>
        </v-flex>
      </v-card-title>
      <v-data-table :headers="headers" v-model="selected" :items="locations" :select-all="hidden" item-key="CSPID"
        :search="search" :pagination.sync="pagination">
        <template slot="items" slot-scope="props">
          <tr>
            <td class="text-left small-td pointer">
              {{ props.item.createdAt | moment("from", "now") }}
            </td>
            <td class="text-left pointer">
              <span v-if="props.item.ClickImage">
                <img class="mr-2" :src="props.item.ClickImage.url"
                  v-if="props.item.ClickImage && props.item.ClickImage.url" width="30" height="20" />
              </span>
              <span>{{ props.item.Store.businessName }} </span>
            </td>
            <td class="text-left pointer">{{ props.item.Store.address }}</td>
            <td class="text-left pointer">{{ props.item.Store.businessPhone }}</td>
            <td class="text-left pointer">{{ props.item.Store.businessEmail }}</td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">Your search for "{{ search }}" found no
          results.</v-alert>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

export default {
  props: ["hidden", "locations", "hideHeader"],
  name: "location-list",
  data() {
    return {
      selected: [],
      terminalURL: process.env.VUE_APP_TERMINALURL,
      headers: [
        {
          text: this.$t("labels.clickOn"),
          align: "left",
          sortable: true,
          value: "createdAt"
        },
        {
          text: this.$t("labels.name"),
          value: "Store.businessName",
          sortable: true
        },
        {
          text: this.$t("labels.address"),
          value: "Store.address",
          sortable: false
        },
        {
          text: this.$t("labels.phoneNumber"),
          value: "Store.businessPhone",
          sortable: false
        },
        {
          text: this.$t("labels.emailAddress"),
          value: "Store.businessEmail",
          sortable: false
        }
      ],
      search: null,
      loading: true,
      pagination: {
        rowsPerPage: 10,
        sortBy: "createdAt"
      }
    };
  },
  computed: {
    ...mapGetters("global", ["currentOrganization", "currentUser", "organizationList"])
  },
  methods: {
    ...mapActions("location", ["setLocation"]),
    create() {
      this.$router.push({ path: "/location/new" });
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.locations.slice();
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    }
  }
};
</script>
